"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mui_1 = require("tss-react/mui");
const classnames_1 = __importDefault(require("classnames"));
const react_2 = require("@emotion/react");
const Button_1 = __importDefault(require("@mui/material/Button"));
const Menu_1 = __importDefault(require("@mui/material/Menu"));
const Flag_1 = __importDefault(require("@mui/icons-material/Flag"));
const OutlinedFlag_1 = __importDefault(require("@mui/icons-material/OutlinedFlag"));
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
const ListItemIcon_1 = __importDefault(require("@mui/material/ListItemIcon"));
const transactionsConfig_1 = require("components/TransactionRegister/transactionsConfig");
const style_1 = require("./style");
const useStyles = (0, mui_1.makeStyles)()(style_1.styles);
const FlagField = (_a) => {
    var { value, autoFocus, inputRef, onChange, editable, includeEmpty, show } = _a, other = __rest(_a, ["value", "autoFocus", "inputRef", "onChange", "editable", "includeEmpty", "show"]);
    const { classes } = useStyles();
    const theme = (0, react_2.useTheme)();
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const btnRef = (0, react_1.useRef)(null);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        event.stopPropagation();
    };
    const handleClose = (item) => {
        setAnchorEl(null);
        if (onChange && item) {
            onChange({ target: { value: item.value ? String(item.value) : null } });
        }
        setTimeout(() => { var _a; return (_a = btnRef.current) === null || _a === void 0 ? void 0 : _a.focus(); }, 100);
    };
    const setButtonRef = (ref) => {
        btnRef.current = ref;
        if (inputRef) {
            inputRef(ref);
        }
    };
    const onKeyDown = (event) => {
        if (event.key === 'Escape' || event.key === 'Enter') {
            event.stopPropagation();
        }
        if (event.key === 'Escape')
            handleClose(null);
    };
    const makeMenuItem = (item) => {
        if (!item.inMenu)
            return '';
        return (<MenuItem_1.default key={`flagmenu:${item.label}`} onClick={() => handleClose(item)}>
        <ListItemIcon_1.default>
          {item.value !== 'NONE' ?
                <Flag_1.default style={{
                        fontSize: 20,
                        color: item.color,
                    }}/>
                :
                    <OutlinedFlag_1.default style={{
                            fontSize: 20,
                            color: theme.palette.text.input,
                        }}/>}
        </ListItemIcon_1.default>
      </MenuItem_1.default>);
    };
    const menuItems = transactionsConfig_1.flagFieldOptions.map((item) => makeMenuItem(item));
    if (includeEmpty) {
        menuItems.push(makeMenuItem({ label: ' No Change', value: null }));
    }
    const currItemRef = value ? transactionsConfig_1.flagFieldOptions.find((x) => String(x.value) === String(value)) : null;
    return (<div {...other}>
      {show &&
            <Button_1.default {...other} classes={{ root: classes.buttonRoot }} autoFocus={autoFocus} aria-owns={anchorEl ? 'flagField-menu' : undefined} aria-haspopup="true" onClick={handleClick} ref={setButtonRef}>
          {(currItemRef && currItemRef.value !== 'NONE') ?
                    (<Flag_1.default style={{ color: currItemRef.color }} className={classes.iconRoot}/>) :
                    (<OutlinedFlag_1.default className={(0, classnames_1.default)(classes.iconRoot, editable ? 'editable' : '')}/>)}
        </Button_1.default>}
      <Menu_1.default id="simple-menu" anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => handleClose(null)} onKeyDown={onKeyDown}>
        {menuItems}
      </Menu_1.default>
    </div>);
};
exports.default = FlagField;
